<template>
    <div>
        <el-menu :default-active="activeIndex" @select="handleSelect">
            <el-menu-item index="5" style="margin-left: -30px">
               <Icon type="md-list" size="18" />
                <span slot="title">组织列表</span>
            </el-menu-item>
            <el-menu-item index="1">
                <Icon type="ios-contacts" />
                <span slot="title">显示对象</span>
            </el-menu-item>
            <el-menu-item index="2">
                <Icon type="md-person-add" size="18" />
                <span slot="title">添加对象</span>
            </el-menu-item>
            <el-menu-item index="3">
                <Icon type="md-cloud-upload" size="18" />
                <span slot="title">上传对象</span>
            </el-menu-item>
            <el-menu-item index="4">
                <Icon type="ios-star" size="18" />
                <span slot="title">标签管理</span>
            </el-menu-item>
            <el-menu-item index="6">
                <Icon type="ios-settings" size="18" />
                <span slot="title">组织管理</span>
            </el-menu-item>
            
        </el-menu>
    </div>
</template>
<script>
import {Icon} from 'iview'
export default {
    components: {
      Icon
    },
    props: ['activeIndex'],
    data() {
        return {
            
        }
    },
    created() {
        //this.activeIndex = 
    },
    methods: {

        handleActiveIndex() {
            console.log(this.$route)
        },
        handleSelect(key, keyPath) {
            //console.log(keyPath)
            //this.activeIndex = keyPath[0]
            if (key == '1') {
                var name = 'duixianglists'

            }
            if (key == '2') {
                var name = 'new_by_form'

            }
            if (key == '3') {
                var name = 'upload'

            }
            if (key == '4') {
                var name = 'tags_manage'

            }
            if (key == '6') {
                var name = 'group_manage'

            }
            this.$router.push({
                name: name,
                params: {
                    group_id: this.$route.params.group_id
                }
            })
            if (key == '5') {
                this.$router.push({
                    path: '/newduixiang'
                })
            }
        },
    }
}
</script>